module.exports = __webpack_public_path__ + "img/fruit-pomegranates-350x184.4f4cc50a.jpg";